import {Globals} from './Globals';
import {cuppa, log} from '../../cuppa/cuppa';
import {UserCtrl} from './UserCtrl';
import {Constants} from './Constants';
import {ConversationsCtrl} from './ConversationsCtrl';
import {CuppaStorage} from "../../cuppa/cuppa.storage";
import {NotificationCtrl} from "./NotificationCtrl";
import {Utils} from "./Utils";
import {OrganizationCtrl} from "./OrganizationCtrl";
import {Storages} from "./Storages";

export class SocketManager{
	static url;
	static ws;

	static getSocketURL(){
		let base = `${document.location.protocol}//${document.location.host}`;
		let url = (base.indexOf("https") !== -1) ? cuppa.replace(base, 'https','wss') : cuppa.replace(base, 'http','ws');
			if(url.indexOf(':3000') !== -1) url = cuppa.replace(url, ':3000', ':4000');
		return url;
	}

	static async connect(){
		SocketManager.disconnect();
		SocketManager.url = SocketManager.getSocketURL();
		SocketManager.ws = new cuppa.Socket(this.url, {connectedCallback:this.onConnected, messageCallback:this.onMessage, closeCallback:()=>log("ON DISCONNECTED")});
	}

	static async onConnected(){
		let user = UserCtrl.getUser();
		let anonymousUser = null;
		let info = {key:await UserCtrl.geyKey(), user, anonymousUser};
		SocketManager.sendMessage({message:Constants.INITIAL_USER_INFO, info});
	}

	static async onMessage(data){
		log("onMessage", data)
		if(cuppa.isJson(data)) data = JSON.parse(data);
		if(data.message === Constants.NEW_CONVERSATION_MESSAGE){
			CuppaStorage.setData({name:Constants.NEW_CONVERSATION_MESSAGE, data}).then();
			NotificationCtrl.showNewConversationMessage(data).then();
		}else if(data.message === Constants.NEW_CONVERSATION){
			CuppaStorage.setData({name:Constants.NEW_CONVERSATION, data:null}).then();
		}else if(data.message === Constants.CONVERSATION_TAKEN){
			let user = UserCtrl.getUser();
			if(user){
				//ConversationsCtrl.getRequestedConversations().then();
			}
		}else if(data.message === Constants.UPDATE_STORAGE){
			if(!data.name) return;
			CuppaStorage.setData({name:data.name, data:data}).then();
		}else if(data.message === Constants.PERSONAL_INFO_RESULT){
			CuppaStorage.setDataSync({...Storages.reloadConversation, data:{conversationId:data?.conversationId}});
			NotificationCtrl.add({
				title:"Personal Information",
				message:"Peer has answered your request for personal information.",
				openCallback:()=>{
					Utils.redirect(`/conversations/conversation/?&ref=${data?.conversationId}&tab=personalInfo`, {forcePath:true});
				}
			});
		}
	};

	static sendMessage(data){
		//log("sendMessage", data)
		try{ this.ws.send(data) }catch(err){ log(err); }
	};

	static disconnect(){
		if(this.ws) this.ws.close();
	};
}

